<script>
  export let start;
</script>

<div class="intro">
  <div class="frame">
    <h4>邪魔しないでカメラ</h4>
    <p class="description">
      撮影中に横から手が出てきて邪魔をしてくるカメラアプリです。
      ご使用の際は、このアプリからカメラへのアクセスを許可してください。
    </p>
    <button class="button-primary u-full-width" on:click={start}>
      撮影開始
    </button>
    <div class="space" />
    <hr />
    <footer class="copyright">
      © 2021
      <a
        href="https://twitter.com/de_teiu_tkg"
        target="_blank"
        rel="noopener noreferrer"
      >
        @de_teiu_tkg
      </a>
    </footer>
  </div>
</div>

<style>
  .intro {
    width: 100%;
    height: 100%;
    background-color: rgb(200, 200, 200);
    background-image: url(/background.jpg);
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .frame {
    background-color: rgba(255, 255, 255, 0.9);
    padding: 10px;
    border-radius: 10px;
    width: 413px;
    height: 480px;
    max-width: 90%;
    max-height: 90%;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 8px 5px rgba(32, 32, 32, 0.4);
  }

  .space {
    flex-grow: 1;
  }

  .description {
    text-align: left;
    margin-bottom: 80px;
  }
</style>
